module.exports = __webpack_public_path__ + "img/pbl02_13.b7fa2e3f.jpg";